<template>
  <div class="campaigns login">
    <div class="inner-content">
      <v-alert :type="alert.type" v-model="alert.show" class="mt-5" dismissible>
        {{ alert.message }}
      </v-alert>

      <v-form @submit="login">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field filled name="email" type="text" v-validate="'required|email'" v-model="username"
              label="Електронна поща" :error-messages="errors.collect('email')" @keyup.enter="login"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field filled name="password" type="password" v-model="password" label="Парола"
              v-validate="'required'" :error-messages="errors.collect('password')" @keyup.enter="login"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn color="primary" @click="login" class="mr-4" :disabled="submitDisabled"
              :loading="loading">Влез</v-btn>
            <v-btn color="secondary" @click="openQrScanner" v-if="hasScanner">Вход с QR код</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="social-login-buttons">
              <v-btn color="#DD4B39" class="white--text mb-5" @click="loginGoogle">
                <v-icon class="mr-2">exit_to_app</v-icon>
                Sign in with Google
              </v-btn>
              <v-btn v-if="showAppleLogin" color="#000000" class="white--text mb-5" @click="loginApple">
                <v-icon class="mr-2">exit_to_app</v-icon>
                Sign in with Apple
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col>
            <v-btn color="secondary" :to="{ name: 'registration' }" class="mt-5 mb-5 mr-4">Създай профил</v-btn>
            <v-btn :to="{ name: 'forgot-pass' }" class="mt-5 mb-5 mr-4">Забравена парола</v-btn>
          </v-col>
        </v-row>

        <div class="privacy-policy" v-if="isIos">
          <a href="https://dabulgaria.bg/privacy-policy-app/"> Privacy Policy </a>
        </div>

      </v-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Capacitor } from '@capacitor/core'
import { canShowAppleLogin } from '@/appleSignIn'

export default {
  name: 'Login',

  data() {
    return {
      showError: false,
      username: '',
      password: '',
      error: false
    }
  },

  mounted() {
    if (typeof this.$route.query.register !== 'undefined') {
      if (this.$route.query.register === 'success') {
        this.$store.commit('showAlert', { type: 'success', message: 'Вашата регистрация беше успешно потвърдена.' })
      } else if (this.$route.query.register === 'fail') {
        this.$store.commit('showAlert', { type: 'error', message: 'Не можахме да потвърдим Вашата регистрация. Възможно е линкът за потвърждение да е вече използван или изтекъл.' })
      }
    }
  },

  watch: {
    username(newValue) {
      this.username = newValue.replace(/ /g, '')
    }
  },

  methods: {
    dismissError() {
      this.error = false
      this.showError = false
    },

    login() {
      if (this.submitDisabled) return

      this.$store.commit('setLoading', true)

      this.$store.dispatch('login', {
        username: this.username,
        password: this.password
      }).then(() => {
        // success
        this.$store.commit('setLoading', false)
        this.$router.push({ name: 'news' })
      }).catch(() => {
        this.$store.commit('showError', 'Грешно потребителско име и/или парола.')
        this.$store.commit('setLoading', false)
      })
    },

    openQrScanner() {
      this.$store.dispatch('qrScan')
        .then(contents => {
          if (contents.token) {
            const redirect = contents.event && contents.event.slug ?
              this.encodeURI('/събития/' + contents.event.slug) : ''
            this.$router.replace('/вход/token/' + contents.token + '/' + redirect)
          }
        })
        .catch(err => {
          console.log(err)
          this.$store.commit('showError', 'QR скенерът не може да бъде отворен в момента.')
        })
    },

    encodeURI(uri) {
      return btoa(encodeURI(uri))
    },

    loginFacebook() {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('loginFacebook').catch(() => {
        this.$store.commit('showError', 'Грешка при входа с Facebook. Моля опитайте по-късно.')
      }).finally(() => {
        this.$store.commit('setLoading', false)
      })
    },

    loginGoogle() {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('loginGoogle').then(() => {
        this.$router.push({ name: 'news' })
      }).catch((err) => {
        if (err) {
          this.$store.commit('showError', err)
        }
      }).finally(() => {
        this.$store.commit('setLoading', false)
      })
    },

    loginApple() {
      if (!this.showAppleLogin) {
        return
      }

      this.$store.commit('setLoading', true)
      this.$store.dispatch('loginApple').then(() => {
        this.$router.push({ name: 'news' })
      }).catch((err) => {
        if (err) {
          this.$store.commit('showError', err)
        }
      }).finally(() => {
        this.$store.commit('setLoading', false)
      })
    }
  },

  computed: {
    submitDisabled() {
      return this.loading || this.username.length === 0 || this.password.length === 0 ||
        this.errors.items.length > 0 || this.loading
    },
    hasScanner() {
      return typeof window.cordova !== 'undefined'
    },
    isIos() {
      return Capacitor.getPlatform() === 'ios'
    },
    showAppleLogin() {
      return canShowAppleLogin()
    },
    ...mapGetters(['loading', 'loggedIn', 'authToken', 'alert'])
  }
}
</script>

<style lang="scss">
.social-login-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .v-btn {
    text-transform: none;
  }
}

.privacy-policy {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  width: 100%;

  a {
    color: rgba(0, 0, 0, .67) !important;
    margin-top: 28px;
    font-size: 18px;
  }
}
</style>
